import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';

export default [
  <Route key="/business/showcase/necklace" element={<ShowocaseLayout />}>
    <Route path="business/showcase/necklace" element={<AsyncPage />} />
  </Route>,
];
